import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import * as Actions from './../store/actions';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FlipMove from 'react-flip-move';
import AnswerListEdit from './QuestionAnswers';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import AssetUpload from 'main/content/asset/AssetUpload';

import {
    ExpansionPanel,
    ExpansionPanelSummary,
    ExpansionPanelDetails,
    Typography,
    Button,
    TextField,
    IconButton,
    Icon,
    Dialog,
    Select,
    InputLabel,
    MenuItem,
    FormControl,
    DialogTitle,
    DialogActions,
    Card,
    CardContent,
    CardHeader,
    Tooltip,
    Input,
    List,
    Grid,
    OutlinedInput,
    FormControlLabel,
    Checkbox,
} from '@material-ui/core';


const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200,
    },
    button: {
        margin: theme.spacing.unit,
    },
    expansion: {
        background: '#FAFAFA',
    }
});

class QuestionEdit extends Component {
    state = {
        expansionPanelOpen: false,
        dialogOpen: false,
        dialogActionType: "",
        dialogParams: {},
        dialogText: "",
    }

    handleChange = (field_name) => (event) => {
        const { question, updateQuestion, changeQuestionType } = this.props;

        let value = event.target.value;
        if (event.target.type === 'checkbox') {
            value = event.target.checked ? 1 : 0;
        }

        if(field_name === 'question_type_id') {
            this.questionTypeDialogOpen(question.header.question_id, value);
        } else {
            const update_data = {
                [field_name]: value
            }

            updateQuestion(question.header.question_id, update_data);
        }
    }

    handleBlur = (field_name) => (event) => {
        const { question, updateQuestion } = this.props;
        let new_value = event.target.value;

        if (isNaN(new_value)) {
            new_value = Number(0);
        } else {
            new_value = Math.abs(Number(new_value));
        }

        if (field_name === 'Score') {
            new_value = Number(new_value).toFixed(1);
        }

        const update_data = {
            [field_name]: new_value
        }
        updateQuestion(question.header.question_id, update_data, true);
    }

    questionTypeDialogOpen = (question_id, question_type_id) => {
        const { changeQuestionType, question } = this.props;
        const old_question_type_id = this.props.question.header.question_type_id;

        if ( // If moving from MultipleChoice <=> MultipleAnswer OR LongAnswer <=> ShortAnswer OR Answer Empty
            ((old_question_type_id === 4 || old_question_type_id === 1 || old_question_type_id === 5) && (question_type_id === 4 || question_type_id === 1 || question_type_id === 5))
            ||
            ((old_question_type_id === 2 || old_question_type_id === 3) && (question_type_id === 2 || question_type_id === 3))
            ||
            (question.answerList.length === 1 && question.answerList[0].header.AnswerText === "")
            ||
            (question.answerList.length <= 0)
        ) {
            changeQuestionType(question_id, question_type_id);
        } else {
            this.setState({
                ...this.state,
                dialogOpen:       true,
                dialogActionType: "ChangeQuestionType",
                dialogParams:     { question_id, question_type_id },
                dialogText:       "Warning: Changing question types may delete existing answers. Are you sure you want to change question type?",
            });
        }

    }

    deleteDialogOpen = (event, question_id) => {
        event.preventDefault();
        event.stopPropagation();
        const { deleteQuestion } = this.props;

        // If Question is empty, no confirmation needed
        if(this.props.question.header.QuestionText === '') {
            deleteQuestion(question_id);
        } else {
            this.setState({
                ...this.state,
                dialogOpen:            true,
                dialogActionType:      "DeleteQuestion",
                dialogParams:          { question_id },
                dialogText:            "Are you sure you want to delete this Question?",
            });
        }
    }

    deleteDialogClose = (dialog_action) => {
        const { deleteQuestion, changeQuestionType } = this.props;

        if (dialog_action) {
            switch(this.state.dialogActionType)
            {
                case ("DeleteQuestion"):
                {
                    deleteQuestion(this.state.dialogParams.question_id);
                    break;
                }

                case ("ChangeQuestionType"):
                {
                    changeQuestionType(this.state.dialogParams.question_id, this.state.dialogParams.question_type_id);
                    break;
                }

                default: {}
            }
        }

        this.setState({
            ...this.state,
            dialogOpen:       false,
            dialogActionType: "",
            dialogParams:     {},
            dialogText:       "",
        })
    }

    handleMoveQuestion = (event, question_id, DisplayOrder, direction) => {
        event.preventDefault();
        event.stopPropagation();
        
        this.props.moveQuestion(question_id, DisplayOrder, direction);
    }

    render() {
        const { question, classes, addAnswer, deleteQuestion, moveQuestion, view_type, viewQuestion, scrollToRef, questionTypes } = this.props;
        return (
            <ExpansionPanel
                ref={scrollToRef}
                expanded={question.isOpen || false}
            >
                <Dialog
                    open={this.state.dialogOpen}
                    onClose={this.deleteDialogClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    disableRestoreFocus={true}
                    onBackdropClick={() => this.deleteDialogClose(false)}
                >
                    <DialogTitle id="alert-dialog-title">{this.state.dialogText}</DialogTitle>
                    <DialogActions>
                        <Button onClick={() => this.deleteDialogClose(false)} color="primary">
                            No
                        </Button>
                        <Button onClick={() => this.deleteDialogClose(true)} color="primary" autoFocus>
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>

                <ExpansionPanelSummary
                    className={classes.expansion}
                    onClick={() => viewQuestion(question.header.question_id)}
                    expandIcon={
                        <ExpandMoreIcon />
                    }
                >
                    <Grid container>
                        <Grid item xs={1}>
                            <Grid container>
                                <Grid item xs={6}>
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <IconButton
                                                variant="contained"
                                                onClick={(event) => this.handleMoveQuestion(event, question.header.question_id, question.header.DisplayOrder, 'UP')}
                                                disabled={view_type === 'detail'}
                                            >
                                                <Icon style={{ fontSize: 15 }}>arrow_upward</Icon>
                                            </IconButton>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <IconButton
                                                variant="contained"
                                                onClick={(event) => this.handleMoveQuestion(event, question.header.question_id, question.header.DisplayOrder, 'DOWN')}
                                                disabled={view_type === 'detail'}
                                            >
                                                <Icon style={{ fontSize: 15 }}>arrow_downward</Icon>
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography>{'(' + question.header.DisplayOrder + ') '}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={10}>
                            <Typography>{question.header.QuestionText.length > 450 ? question.header.QuestionText.substring(0, 450) + "..." : question.header.QuestionText}</Typography>
                        </Grid>

                        <Grid item xs={1}>
                            <Tooltip title="Delete Question">
                                <IconButton
                                    variant="contained"
                                    onClick={(event) => this.deleteDialogOpen(event, question.header.question_id)}
                                    disabled={view_type === 'detail'}
                                    hidden={view_type === 'detail'}
                                >
                                    <Icon style={{ color: 'red' }}>close</Icon>
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Grid container spacing={24}>
                        <Grid item xs={12}>
                            <TextField
                                label="Question Text"
                                multiline={true}
                                rows={2}
                                rowsMax={4}
                                value={question.header.QuestionText}
                                onChange={this.handleChange('QuestionText')}
                                margin="normal"
                                fullWidth
                                disabled={view_type === 'detail'}
                                variant="outlined"
                                autoFocus
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <Card>
                                <CardHeader
                                    title={'Question Detail'}
                                />
                                <CardContent>
                                    <Grid container spacing={16}>
                                        <Grid item xs={12}>
                                            <TextField
                                                label="Question Total Points"
                                                value={Number(question.header.Score).toFixed(1)}
                                                onChange={this.handleChange('Score')}
                                                onBlur={this.handleBlur('Score')}
                                                margin="normal"
                                                disabled={view_type === 'detail'}
                                                variant="outlined"
                                                type='number'
                                                inputProps={{
                                                    min: 0,
                                                    step: 1
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl className={classes.FormControl} variant="outlined">
                                                <InputLabel htmlFor="question_type_id">Question Type</InputLabel>
                                                <Select
                                                    value={question.header.question_type_id}
                                                    onChange={this.handleChange('question_type_id')}
                                                    input={
                                                        <OutlinedInput
                                                            labelWidth={"Question Type".length * 8}
                                                            name="question_type_id"
                                                            id="question_type_id"
                                                        />
                                                    }
                                                    disabled={view_type === 'detail'}
                                                >
                                                    {questionTypes.map((question_type) =>
                                                        <MenuItem
                                                            value={question_type.question_type_id}
                                                            key={question_type.question_type_id}
                                                        >
                                                            {question_type.DisplayName}
                                                        </MenuItem>
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={(question.header.RandomizeAnswerOrder === 1 || question.header.RandomizeAnswerOrder === true)}
                                                        onChange={this.handleChange('RandomizeAnswerOrder')}
                                                        value="RandomizeAnswerOrder"
                                                        color="primary"
                                                    />
                                                }
                                                label="Randomize Answer Order"
                                                disabled={view_type === 'detail'}
                                            />
                                        </Grid>
                                        {question.header.question_type_id === 6 && view_type !== 'detail'? // Hotspot
                                            <Grid item xs={12}>
                                                <AssetUpload
                                                    file_type={"Hotspot Question"}
                                                    auth_id={this.props.auth.user.data.auth_id}
                                                    modelType={"question"}
                                                    model_id={question.header.question_id}
                                                    requires_relation={false}
                                                    responseFunction={(question_id, responseData) => {
                                                        this.props.updateQuestionImage(question_id, responseData.insert_id, responseData.AssetName, responseData.URL);
                                                    }}
                                                    displayText={"Upload Image"}
                                                />
                                                {question.image.AssetName || 'No Image Uploaded'}
                                            </Grid>
                                            : ''
                                        }
                                        
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={9}>
                            <AnswerListEdit
                                question={question}
                                classes={classes}
                                view_type={view_type}
                            />
                        </Grid>
                    </Grid>
                </ExpansionPanelDetails>
            </ExpansionPanel>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateQuestion:      Actions.updateQuestion,
        deleteQuestion:      Actions.deleteQuestion,
        addQuestion:         Actions.addQuestion,
        addAnswer:           Actions.addAnswer,
        moveQuestion:        Actions.moveQuestion,
        viewQuestion:        Actions.viewQuestion,
        changeQuestionType:  Actions.changeQuestionType,
        updateQuestionImage: Actions.updateQuestionImage,
    }, dispatch);
}

function mapStateToProps({ auth, questionApp }) {
    return {
        auth,
        questionTypes:   questionApp.questions.questionTypes,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(QuestionEdit)));



// WEBPACK FOOTER //
// src/main/content/quiz/quizBuilder/QuestionEdit.js